import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadAdjustments = async () => {
  try {
    const response = await Axios.get('adjustments');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadProductAdjustment = async (action) => {
  try {
    const response = await Axios.get('adjustments/product/'+action);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};


const loadOneAttribute = async (name) => {
  try {
    const respnse = await Axios.get('adjustments/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}


export const loadInventoryLocation = async (action) => {
  try {
    const response = await Axios.get('adjustments/location/'+action);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadAttribute = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const data = await loadOneAttribute(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}


export const loadAdjustmentHistory = async (action) => {
  try {
    const response = await Axios.get('adjustments/product/moves/history/'+action);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

const useInventoryAdjustmentAPI = () => {
  const { error } = useOutletContext();
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('adjustments', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('adjustment_response', 'reload');
    }catch(err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response.data);
      }
      throw err;
    }
  }

  const update = async (data, success) => {
    try {
      const respnse = await Axios.put('adjustments/update/one', data);
      const responseData = await respnse.data;
      success(responseData.message);
      setTimeout(() => {
        EventEmitter.dispatch('adjustment_response', 'reload');
      }, 1000);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response.data);
      }
      throw err;
    }
  }

  const apply = async (data, success) => {
    try {
      const respnse = await Axios.put('adjustments/apply/one', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('adjustment_response', 'reload');
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response.data);
      }
      throw err;
    }
  }



  return { create, update, apply };
};



export default useInventoryAdjustmentAPI;


